import { render, staticRenderFns } from "./QuestionnaireStepActions.vue?vue&type=template&id=f0b767c6&lang=pug"
import script from "./QuestionnaireStepActions.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireStepActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports